import { render, staticRenderFns } from "./TeacherTypeDetail.vue?vue&type=template&id=39791942"
import script from "../../controllers/teacher_type/teacher-type-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/teacher_type/teacher-type-detail.js?vue&type=script&lang=js&external"
import style0 from "./TeacherTypeDetail.vue?vue&type=style&index=0&id=39791942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports